import React from "react";


export default class TipsView extends React.Component {
    render() {
        const { msg } = this.props
        return (
            <>
                {
                    msg && msg != '' && <div className="tipsMsg">
                        <p className="tipsMsgItem">{msg}</p>
                    </div>
                }
            </>
        )
    }
}


